module.exports = __webpack_public_path__ + "static/media/icon_familyFun.08737476.svg";